export const ADD_SYSTEM_MESSAGE = "@@SYSMSG_ADD";
export const REMOVE_SYSTEM_MESSAGE = "@@SYSMSG_REMOVE";
export const CLEAR_SYSTEM_MESSAGES = "@@SYSMSG_CLEAR";
